import { orderBy } from "lodash";
import { Item__Atividades } from "../../../../../../../../services/atividades/GET";
import { Item__EquipeCliente } from "../../../../../../../../services/Equipe/GET";


export function atividadesPorTipo(lista_atividades: Item__Atividades[], tipo_atividade: 'Executadas'|'Planejadas', data_equipe_cliente: Item__EquipeCliente[]) {

    function obterNomeOperador(cod_usuario: number) {
        return data_equipe_cliente?.find(i=> i.cod_func === cod_usuario)?.usuario_nome ?? '?';
    }
    
    const cod_tipo_atv = tipo_atividade==='Planejadas' ? 1 : 2;
    const atividades = (lista_atividades??[]).filter(i=> i.cod_tipo === cod_tipo_atv);

    if (tipo_atividade==='Planejadas') {
        return orderBy(atividades, ['dias', 'data_inicio', 'data_final']);
    }
    
    let incluir_info_atv = (atividades??[]).map((i)=>{
        return {
            andamentos: (i.andamentos??[]).map((j)=> {
                return {
                    ...j,
                    descricao : i.descricao,
                    cod_atividade_planejada: i.cod_atividade,
                    data_inicio_atv: i.data_inicio,
                    data_final_atv: i.data_final,
                    data_conclusao: undefined,
                    dias: i.dias,
                    tipo_operacao: i.tipo_operacao,
                    cod_usuario: j.cod_usuario,
                    operador_nome: j.cod_usuario ? obterNomeOperador(j.cod_usuario) : j.operador_nome,
                    area: j.area,
                    //@ts-ignore
                    patrimonios: (j.patrimonios??[]).map(k=> k.patrimonio_nome)?.flat(),
                    //@ts-ignore
                    insumos: (j.insumos??[]).map(k=> k.insumo_nome)?.flat(),
                }
            })
        }
    //@ts-ignore
    })?.map(i=> i.andamentos)?.flat();

    let add_nome_atv = (incluir_info_atv??[]).map(i=> {
        return {
            ...i,
            descricao: (lista_atividades??[]).find(j=>j.cod === i.cod_atividade_planejada)?.descricao ?? ''
        }
    });

    return orderBy(add_nome_atv, 'data_inicio_atv') ?? []
}